import { type QueryHookOptions, useQuery } from "@apollo/client";
import { TagQuery } from "../graphql/queries";
import type { TagQueryType } from "@/types/graphql/partner.generated";

export const useTagQuery = (options?: QueryHookOptions<TagQueryType>) => {
  return useQuery<TagQueryType>(TagQuery, options);
};
